<ng-template #ticketheader>
    <ng-container *ngIf="ticket">
        <upp-header color="light" [menu]="CanBack ? 'hide' : 'show'" [lines]="(ticket.ToInvoice || ticket.HasPartial) ? 'warning' : 'success'">
            <upp-header-title>
                <span uppDataid="ticketedit-header-size" class="title-field">
                    <ion-icon name="cart-outline"></ion-icon>
                    <span class="size">{{ticket.ProductsLength}}</span>
                </span>
                <span *ngIf="view.Desktop && ticket.qrcode !== null" uppDataid="ticketedit-header-tableno" class="title-field"  tabindex="0" (click)="OnViewTable()" (keydown.enter)="OnViewTable()" (keydown.space)="OnViewTable()">
                    <ng-container *ngIf="ticket.qrcode.alias === null">
                        <span class="table"><span class="small">{{tr('@place_ticket_table')}}:</span>{{ticket.qrcode.number}}</span>
                    </ng-container>
                    <ng-container *ngIf="ticket.qrcode.alias !== null">
                        <span class="table small">{{ticket.qrcode.alias}}</span>
                    </ng-container>
                </span>
                <span *ngIf="view.Desktop && ticket.qrcode === null" uppDataid="ticketedit-header-tableno" class="title-field" >
                    <span class="table small">{{tr('@place_ticket_barticket')}}</span>
                </span>
                <span uppDataid="ticketedit-header-price" class="title-field" *ngIf="AmountToPay as amount">
                    <span class="price">{{amount.int}},<span class="decimal">{{amount.dec}}</span>{{tr('@currency')}}</span>
                </span>
            </upp-header-title>
            <upp-header-button uppDataid="ticketedit-back-button" *ngIf="CanBack" (click)="OnBack()">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </upp-header-button>
            <upp-header-button uppDataid="ticketedit-header-diners-button" *ngIf="CanDiners" (click)="OnDiners()">
                <ion-icon name="people-outline"></ion-icon>
            </upp-header-button>
            <upp-header-button uppDataid="ticketedit-close-button" (click)="OnClose()">
                <ion-icon name="close-outline"></ion-icon>
            </upp-header-button>
        </upp-header>    
    </ng-container>
</ng-template>

<ng-template #ticketactions>
    <div class="ticket-edit-status" *ngIf="ticket">
        <ion-item uppDataid="ticketedit-header-action"  class="operation" [ngClass]="StatusColor" lines="full">
            <!-- TICKET STATUS (VIEW MODE) -->
            <ng-container *ngIf="mode === 'VIEW'">
                <ng-container *ngIf="ticket.IsCancelled === true">
                    <ion-icon slot="start" name="close-circle-outline"></ion-icon>
                    <ion-label>{{tr('@place_ticket_cancelled')}}</ion-label>    
                </ng-container>
                <ng-container *ngIf="ticket.IsCancelled !== true">
                    <ng-container *ngIf="ticket.IsPaid !== true">
                        <ion-icon slot="start" name="list-circle-outline"></ion-icon>
                        <ion-label>{{tr('@place_ticket_not_paid')}}</ion-label>    
                    </ng-container>
                    <ng-container *ngIf="ticket.payment === 'PAYACCOUNT' && (ticket.IsPaid || ticket.IsToPay)">
                        <ion-icon slot="start" name="ribbon-outline"></ion-icon>
                        <ion-label>
                            {{tr('@place_ticket_accountpaid')}}
                            <span *ngIf="PayAccountName" class="ticket-payaccount-name">{{PayAccountName}}</span>
                        </ion-label>
                    </ng-container>
                    <ng-container *ngIf="(ticket.IsPaid === true) && (ticket.payment === 'PAYCASH')">
                        <ion-icon slot="start" name="cash-outline"></ion-icon>
                        <ion-label>{{tr('@place_ticket_cashpaid')}}</ion-label>    
                    </ng-container>
                    <ng-container *ngIf="(ticket.IsPaid === true) && (ticket.payment === 'PAYCARD')">
                        <ion-icon slot="start" name="card-outline"></ion-icon>
                        <ion-label>{{tr('@place_ticket_cardpaid')}}</ion-label>    
                    </ng-container>
                    <ng-container *ngIf="(ticket.IsPaid === true) && (ticket.payment === 'PAYMIXED')">
                        <ion-icon slot="start" name="logo-usd"></ion-icon>
                        <ion-label>{{tr('@place_ticket_mixedpaid')}}</ion-label>    
                    </ng-container>
                    <ng-container *ngIf="(ticket.IsPaid === true) && (ticket.payment === 'PAYLINE')">
                        <upp-online-paid-icon slot="start"></upp-online-paid-icon>
                        <ion-label>{{tr('@place_ticket_linepaid')}}</ion-label>                             
                    </ng-container>
                </ng-container>
            </ng-container>

            <!-- TICKET STATUS (EDIT MODE) -->
            <ng-container *ngIf="mode === 'EDIT'">
                <ng-container *ngIf="IsNewTicket === true">
                    <ion-icon slot="start" name="list-circle-outline"></ion-icon>
                    <ion-label>{{tr('@place_ticket_creation')}}</ion-label>    
                </ng-container>
                <ng-container *ngIf="IsNewTicket !== true">
                    <ion-icon slot="start" name="list-circle-outline"></ion-icon>
                    <ion-label>{{tr('@place_ticket_edition')}}</ion-label>            
                </ng-container>    
            </ng-container>

            <ion-icon UppDataId="ticketedit-show-options" slot="end" name="ellipsis-vertical" *ngIf="CanOptions" (click)="OnTicketOptions()"></ion-icon>
        </ion-item>
        <upp-dropdown [expand]="ShowTicketOptions" (Closed)="OnTicketOptions()">
            <upp-dropdown-title>
                {{tr('@place_ticket_options')}}
            </upp-dropdown-title>            
            <upp-dropdown-content>
                <ion-item UppDataId="ticketview-print-option"
                    *ngIf="control.CanExecute('print')"
                    uppTouch
                    (TouchClick)="control.OnPrintClicked()"
                    (TouchStart)="control.OnPrintPressed(true)"
                    (TouchLeave)="control.OnPrintPressed(false)">
                    <ion-label>{{ ticket.invoice ? tr('@place_ticket_print_invoice') : tr('@place_ticket_print_ticket') }}</ion-label>
                    <ion-icon slot="end" name="print-outline"></ion-icon>
                </ion-item>

                <ion-item UppDataId="ticketview-cardvoucher-option"
                    *ngIf="control.CanExecute('cardvoucher')"
                    (click)="control.Execute('cardvoucher')">
                    <ion-label>{{ tr('@ticket_action_cardvoucher') }}</ion-label>
                    <ion-icon slot="end" name="card-outline"></ion-icon>
                </ion-item>

                <ion-item UppDataId="ticketview-reorder-option" *ngIf="control.CanExecute('reorder')" (click)="control.Execute('reorder')">
                    <ion-label>{{tr('@place_ticket_reorder')}}</ion-label>
                    <ion-icon slot="end" name="restaurant-outline"></ion-icon>
                </ion-item>

                <ion-item UppDataId="ticketedit-ticket-option" *ngIf="control.CanExecute('create')" (click)="control.Execute('create')">
                    <ion-label>{{tr('@place_ticket_create_ticket')}}</ion-label>
                    <ion-icon slot="end" name="add-outline"></ion-icon>
                </ion-item>
                <ion-item UppDataId="ticketedit-mixed-option" *ngIf="control.CanExecute('mixed')" (click)="control.Execute('mixed')">
                    <ion-label>{{tr('@place_ticket_mixed_payment')}}</ion-label>
                    <ion-icon slot="end" name="logo-usd"></ion-icon>
                </ion-item>
                <ion-item UppDataId="ticketedit-partial-option" *ngIf="control.CanExecute('partial')" (click)="control.Execute('partial')">
                    <ion-label>{{tr('@place_ticket_partial_payment')}}</ion-label>
                    <ion-icon slot="end" name="logo-usd"></ion-icon>
                </ion-item>
                <ion-item UppDataId="ticketview-account-option" *ngIf="control.CanExecute('account')" (click)="control.Execute('account')">
                    <ion-label>{{tr('@place_ticket_to_account')}}</ion-label>
                    <ion-icon slot="end" name="ribbon-outline"></ion-icon>
                </ion-item>
                <ion-item UppDataId="ticketview-merge-option" *ngIf="control.CanExecute('merge')" (click)="control.Execute('merge')">
                    <ion-label>{{tr('@place_ticket_merge_ticket')}}</ion-label>
                    <ion-icon slot="end" name="git-merge-outline"></ion-icon>
                </ion-item>
                <ion-item UppDataId="ticketview-split-option" *ngIf="control.CanExecute('split')" (click)="control.Execute('split')">
                    <ion-label>{{tr('@place_ticket_split_ticket')}}</ion-label>
                    <ion-icon slot="end" name="git-branch-outline"></ion-icon>
                </ion-item>
                <ion-item UppDataId="ticketedit-table-option" *ngIf="control.CanExecute('table')" (click)="control.Execute('table')">
                    <ion-label>{{tr('@place_ticket_change_table')}}</ion-label>
                    <ion-icon slot="end" name="scan-outline"></ion-icon>
                </ion-item>
                <ion-item UppDataId="ticketedit-ticket-option" *ngIf="control.CanExecute('discount')" (click)="control.Execute('discount')">
                    <ion-label>{{tr('@place_ticket_apply_discounts')}}</ion-label>
                    <ion-icon slot="end" name="heart-outline"></ion-icon>
                </ion-item>
                <ion-item UppDataId="ticketview-send-option" *ngIf="control.CanExecute('email')" (click)="control.Execute('email')">
                    <ion-label>{{tr('@place_email_invoice')}}</ion-label>
                    <ion-icon slot="end" name="mail-outline"></ion-icon>
                </ion-item>
                <ion-item UppDataId="ticketview-invoice-option" *ngIf="control.CanExecute('invoice')" (click)="control.Execute('invoice')">
                    <ion-label>{{ ticket.invoice ? tr('@place_ticket_set_invoice') : tr('@place_ticket_add_invoice') }}</ion-label>
                    <ion-icon slot="end" name="logo-usd"></ion-icon>
                </ion-item>
                <ion-item UppDataId="ticketview-reopen-option" *ngIf="control.CanExecute('open')" (click)="control.Execute('open')">
                    <ion-label>{{tr('@place_ticket_open_closed')}}</ion-label>
                    <ion-icon slot="end" name="arrow-redo-circle-outline"></ion-icon>
                </ion-item>
                <ion-item UppDataId="ticketview-return-option" *ngIf="control.CanExecute('return')" (click)="control.Execute('return')">
                    <ion-label>{{tr('@place_ticket_choose_return')}}</ion-label>
                    <ion-icon slot="end" name="arrow-undo-circle-outline"></ion-icon>
                </ion-item>
                <ion-item UppDataId="ticketedit-card-option" *ngIf="control.CanExecute('tocard')" (click)="control.Execute('tocard')">
                    <ion-label>{{tr('@place_ticket_change_payment_card')}}</ion-label>
                    <ion-icon slot="end" name="card-outline"></ion-icon>
                </ion-item>
                <ion-item UppDataId="ticketedit-cash-option" *ngIf="control.CanExecute('tocash')" (click)="control.Execute('tocash')">
                    <ion-label>{{tr('@place_ticket_change_payment_cash')}}</ion-label>
                    <ion-icon slot="end" name="cash-outline"></ion-icon>
                </ion-item>

                <ion-item-sliding *ngIf="control.CanExecute('cancel')">
                    <ion-item UppDataId="ticketview-cancel-option" (click)="control.Execute('cancel')">
                        <ion-label color="danger">{{tr('@place_ticket_reject')}}</ion-label>
                        <ion-icon color="danger" slot="end" name="close-circle-outline"></ion-icon>
                    </ion-item>
                    <ion-item-options side="end">
                        <ion-item-option UppDataId="ticketview-error-cancel-option" *ngIf="control.CanExecute('delete')" color="danger" (click)="control.Execute('delete')">
                            <ion-label>{{tr('@place_ticket_delete')}}</ion-label>
                            <ion-icon color="danger" slot="end" name="close-circle-outline"></ion-icon>
                        </ion-item-option>
                    </ion-item-options>
                </ion-item-sliding>
            </upp-dropdown-content>
        </upp-dropdown>       
    </div>
</ng-template>

<ng-template #ticketbuttons>
    <span class="ticketactions" *ngIf="ticket && (ticket.IsOpened || ticket.CanCash || ticket.CanCard)">
        <ion-grid>
            <ion-row>
                <ion-col *ngIf="mode === 'VIEW' && CanEdit">
                    <ion-button uppTouch uppdataId="ticketedit-edit-button" 
                        color="success" 
                        expand="full" 
                        (click)="OnEdit()"
                    >
                        <ion-label>
                            <ion-icon name="restaurant-outline"></ion-icon><br/>                                
                            <span class="small">{{tr('@ticket_action_modify')}}</span>
                        </ion-label>
                    </ion-button>
                </ion-col>
                <ion-col *ngIf="mode === 'EDIT'">
                    <ion-button uppTouch uppdataId="ticketedit-print-button" 
                        [disabled]="!control.CanExecute('print')"
                        color="success" 
                        expand="full" 
                        (TouchClick)="control.OnPrintClicked()"
                        (TouchStart)="control.OnPrintPressed(true)"
                        (TouchLeave)="control.OnPrintPressed(false)"
                    >
                        <ion-label>
                            <ion-icon name="print-outline"></ion-icon><br/>                                
                            <span class="small">{{tr('@ticket_action_print')}}</span>
                        </ion-label>
                    </ion-button>
                </ion-col>

                <ion-col>
                    <ion-button uppDataid="ticketedit-send-button" 
                        [disabled]="!control.CanExecute('send')" 
                        color="success" 
                        expand="full" 
                        (click)="OnCommit(null)"
                    >
                        <ion-label>
                            <ion-icon name="checkmark-circle-outline"></ion-icon><br/>                                
                            <span *ngIf="(IsNewTicket === true)" class="small">{{tr('@ticket_action_send')}}</span>
                            <span *ngIf="(IsNewTicket !== true)" class="small">{{tr('@ticket_action_update')}}</span>
                        </ion-label>
                    </ion-button>                         
                </ion-col>
                <ion-col *ngIf="ticket.place?.CanCash">
                    <ion-button uppDataid="ticketedit-paycash-button" 
                        [disabled]="!control.CanExecute('cash')"
                        color="success" 
                        expand="full"  
                        (click)="OnCommit('PAYCASH')"
                    >
                        <ion-label>
                            <ion-icon name="cash-outline"></ion-icon><br/>                                
                            <span class="small">{{tr('@ticket_action_paycash')}}</span>
                        </ion-label>
                    </ion-button>                        
                </ion-col>
                <ion-col>
                    <ion-button uppDataid="ticketedit-paycard-button" 
                        [disabled]="!control.CanExecute('card')"
                        color="success" 
                        expand="full"  
                        (click)="OnCommit('PAYCARD')"
                    >
                        <ion-label>
                            <ion-icon name="card-outline"></ion-icon><br/>                                
                            <span class="small">{{tr('@ticket_action_paycard')}}</span>
                        </ion-label>
                    </ion-button>                        
                </ion-col>
            </ion-row>
        </ion-grid>
    </span>
</ng-template>

<ng-template #tickettableaction>
    <ion-item class="action">
        <ion-label>{{tr('@place_ticket_action_table')}}</ion-label>
        <ion-icon slot="end" name="scan-outline"></ion-icon>
    </ion-item>
    <upp-form-section fill="clear">
        <ng-container *ngFor="let qrcode of control.TicketTables">
            <upp-qrcode-ticket [uppDataid]="'ticketedit-table-' + qrcode.number + '-thumb'" 
                [ticket]="ticket" 
                [qrcode]="qrcode" 
                (click)="control.OnApplyTable(qrcode)"
            ></upp-qrcode-ticket>            
        </ng-container>
    </upp-form-section>
    <div style="clear: both; height: 10px"></div>
    <ion-button uppDataid="ticketedit-cancel-table" expand="block" fill="clear" color="success" (click)="control.CancelAction()">
        {{tr('@place_ticket_cancel')}}
    </ion-button>    
</ng-template>

<ng-template #ticketaccountaction>
    <ion-item class="action">
        <ion-label>{{tr('@place_ticket_action_account')}}</ion-label>
        <ion-icon slot="end" name="ribbon-outline"></ion-icon>
    </ion-item>
    <upp-form-section fill="clear" uppDataid="ticketedit-account-select">
        <ion-list>
            <ion-radio-group [(ngModel)]="control.SelectedAccount" (ionChange)="control.OnAccountSelected(control.SelectedAccount)">
                <ion-item class="ion-no-padding" *ngFor="let account of (place?.accounts ?? []); trackBy: AccountTrack" [disabled]="account.IsBlocked" [uppDataid]="'ticketedit-account-' + account.objid + '-item'">
                    <ion-label>{{account.name || tr('@place_account_no_name')}}</ion-label>
                    <ion-radio [value]="account" [disabled]="account.IsBlocked" slot="end"></ion-radio>
                </ion-item>
            </ion-radio-group>
        </ion-list>
    </upp-form-section>
    <ion-button uppDataid="ticketedit-submit-payaccount" expand="block" color="success" [disabled]="!control.SelectedAccount || control.SelectedAccount.IsBlocked" (click)="control.OnPayAccount()">
        {{tr('@place_ticket_accept')}}
    </ion-button>
    <ion-button uppDataid="ticketedit-cancel-payaccount" expand="block" fill="clear" color="success" (click)="control.CancelAction()">
        {{tr('@place_ticket_cancel')}}
    </ion-button>
</ng-template>

<ng-template #ticketdiscountaction>
    <ion-item class="action">
        <ion-label>{{tr('@place_ticket_apply_discounts')}}</ion-label>
        <ion-icon slot="end" name="heart-outline"></ion-icon>
    </ion-item>
    <upp-form-section fill="clear">
        <ng-container *ngFor="let discount of control.TicketDiscounts; trackBy: DiscountTrack">
            <upp-discount-thumb [uppDataid]="'ticketedit-discount-' + (tr(discount.name) || '') + '-thumb'" 
                [ticket]="ticket" 
                [discount]="discount" 
                (click)="control.OnApplyDiscount(discount)"
            ></upp-discount-thumb>
        </ng-container>
    </upp-form-section>
    <div style="clear: both; height: 10px"></div>
    <ion-button uppDataid="ticketedit-cancel-discounts" expand="block" fill="clear" color="success" (click)="control.CancelAction()">
        {{tr('@place_ticket_cancel')}}
    </ion-button>    
</ng-template>

<ng-template #ticketinvoiceaction>
    <ion-item uppDataid="ticketedit-invoice-action" class="operation success invoice-action-title" lines="full">
        <ion-icon slot="start" name="receipt-outline"></ion-icon>
        <ion-label>{{tr('@place_ticket_action_invoice')}}</ion-label>
    </ion-item>
    <upp-ticket-invoice uppDataid="ticketedit-invoice-info"
        [ticket]="ticket"
        (Accept)="control.OnInvoiceAccept()"
        (Cancel)="control.CancelAction()">
    </upp-ticket-invoice>
</ng-template>
    
<ng-template #ticketmergeaction>
    <ion-item class="action">
        <ion-label>{{tr('@place_ticket_action_merge')}}</ion-label>
        <ion-icon slot="end" name="git-merge-outline"></ion-icon>
    </ion-item>
    <upp-form-section fill="clear">
        <ng-container *ngIf="control.MergeInfo === null">
            <ng-container *ngFor="let ticket of control.MergeTickets; trackBy: TicketTrack">
                <upp-ticket-thumb [uppDataid]="'ticketedit-mergeticket-' + ticket.orderno + '-thumb'" 
                    [ticket]="ticket"  
                    (click)="control.OnTicketMerge(ticket)"
                ></upp-ticket-thumb>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="control.MergeInfo !== null">
            <upp-ticket-thumb [uppDataid]="'ticketedit-mergeticket-selected-' + control.MergeInfo.target.orderno + '-thumb'" 
                [ticket]="control.MergeInfo.target">
            </upp-ticket-thumb>
        </ng-container>
    </upp-form-section>
    <ion-item class="warning" *ngIf="control.MergeWarning" lines="none" uppDataid="ticketedit-merge-warning">
        <ion-icon slot="start" name="heart-dislike-outline"></ion-icon>
        <ion-label>
            {{tr('@place_ticket_merge_discounts_lost_warning')}}<br/>
            <span class="small">{{tr('@place_ticket_merge_discounts_lost_message')}}</span>
        </ion-label>
    </ion-item>
</ng-template>

<ng-template #ticketmergebuttons>
    <upp-form-buttons>
        <ng-container *ngIf="control.MergeInfo === null">
            <ion-button uppDataid="ticketedit-cancel-merge" expand="block" fill="clear" color="success" (click)="control.CancelAction()">
                {{tr('@place_ticket_cancel')}}
            </ion-button>
        </ng-container>
        <ng-container *ngIf="control.MergeInfo !== null">
            <ion-button uppDataid="ticketview-submit-merge" size="large" expand="block" color="success" [disabled]="control.MergeBlocked" (click)="control.OnMergeCommit()">
                {{tr('@place_ticket_do_merge')}}
            </ion-button>
            <ion-button uppDataid="ticketview-cancel-merge" expand="block" fill="clear" color="success" (click)="control.OnMergeCancel()">
                {{tr('@place_ticket_cancel')}}
            </ion-button>
        </ng-container>
    </upp-form-buttons>
</ng-template>

<ng-template #ticketsplitaction>
    <ion-item class="action">
        <ion-label>{{tr('@place_ticket_action_split')}}</ion-label>
        <ion-icon slot="end" name="git-branch-outline"></ion-icon>
    </ion-item>
</ng-template>

<ng-template #ticketsplitbuutons>
    <upp-form-buttons>
        <ion-button uppDataid="ticketview-submit-split" size="large" expand="block" color="success" [disabled]="!control.CanDoSplit" (click)="control.OnTicketSplit()">
            {{tr('@place_ticket_do_split')}}
        </ion-button>
        <ion-button uppDataid="ticketview-cancel-split" expand="block" fill="clear" color="success" (click)="control.CancelAction()">
            {{tr('@place_ticket_cancel')}}
        </ion-button>
    </upp-form-buttons>
</ng-template>

<ng-template #ticketreturnaction>
    <ion-item class="action">
        <ion-label>{{tr('@place_ticket_action_return')}}</ion-label>
        <ion-icon slot="end" name="arrow-undo-circle-outline"></ion-icon>
    </ion-item>
</ng-template>

<ng-template #ticketreturnoptions>
    <ng-container *ngIf="control.CanDoReturn && control.ReturnPrice > 0">
        <upp-form-section fill="clear" [title]="tr('@place_ticket_return_payment_prompt')">
            <upp-form-warning uppDataid="ticketedit-return-paycash"
                *ngIf="control.CanReturnCash"
                class="ticket-return-payment-option"
                [lines]="control.ReturnRefund === 'PAYCASH' ? 'fill' : 'solid'"
                icon="cash"
                [color]="control.ReturnRefund === 'PAYCASH' ? 'primary' : 'medium'"
                [title]="tr('@place_ticket_return_cash_title', [ control.ReturnPrice.toFixed(2) + tr('@currency') ])"
                [subtitle]="tr('@place_ticket_return_cash_subtitle')"
                (click)="control.OnReturnRefundChange('PAYCASH')">
            </upp-form-warning>
            <upp-form-warning uppDataid="ticketedit-return-paycard"
                *ngIf="control.CanReturnFullCard"
                class="ticket-return-payment-option"
                [lines]="control.ReturnRefund === 'PAYCARD' ? 'fill' : 'solid'"
                icon="card"
                [color]="control.ReturnRefund === 'PAYCARD' ? 'primary' : 'medium'"
                [title]="tr('@place_ticket_return_card_title', [ control.ReturnPrice.toFixed(2) + tr('@currency') ])"
                [subtitle]="tr('@place_ticket_return_card_subtitle')"
                (click)="control.OnReturnRefundChange('PAYCARD')">
            </upp-form-warning>
            <upp-form-warning uppDataid="ticketedit-return-paymixed"
                *ngIf="control.CanReturnAnyCard && control.CanReturnCash"
                class="ticket-return-payment-option"
                [lines]="control.ReturnRefund === 'PAYMIXED' ? 'fill' : 'solid'"
                icon="logo-usd"
                [color]="control.ReturnRefund === 'PAYMIXED' ? 'primary' : 'medium'"
                [title]="tr('@place_ticket_total_return', [ control.ReturnPrice.toFixed(2) + tr('@currency') ])"
                [subtitle]="tr('@place_ticket_return_mixed_subtitle')"
                (click)="control.OnReturnRefundChange('PAYMIXED')">
            </upp-form-warning>
            <upp-form-warning uppDataid="ticketedit-return-cashblocked"
                *ngIf="!control.CanReturnCash && !control.CanReturnFullCard && control.ReturnPrice > 0"
                color="warning"
                icon="alert-circle-outline"
                [title]="tr('@ticket_refund_cash_blocked')">
            </upp-form-warning>
        </upp-form-section>
        <upp-form-section *ngIf="control.ReturnRefund === 'PAYMIXED'" fill="clear" [formGroup]="control.ReturnForm">
            <ion-item lines="none">
                <ion-label>{{tr('@place_ticket_total_return', [ control.ReturnPrice.toFixed(2) + tr('@currency') ])}}</ion-label>
            </ion-item>
            <ion-item lines="full">
                <ion-icon slot="start" name="cash-outline"></ion-icon>
                <upp-input uppDataid="ticketedit-return-cash-text"
                    formControlName="cash"
                    type="price"
                    placeholder="{{tr('@place_ticket_return_cash_ph')}}"
                    (Changed)="control.OnReturnCashChanged()"
                ></upp-input>
            </ion-item>
            <ion-item lines="none">
                <ion-icon slot="start" name="card-outline"></ion-icon>
                <upp-input uppDataid="ticketedit-return-card-text"
                    formControlName="card"
                    type="price"
                    placeholder="{{tr('@place_ticket_return_card_ph')}}"
                    (Changed)="control.OnReturnCardChanged()"
                ></upp-input>
            </ion-item>
        </upp-form-section>
    </ng-container>
</ng-template>

<ng-template #ticketreturnbuttons>
    <upp-form-buttons>
        <ion-button uppDataid="ticketview-submit-return" size="large" expand="block" color="success" [disabled]="!control.CanDoReturn || !control.ReturnReady" (click)="control.OnTicketReturn()">
            {{tr('@place_ticket_do_return')}}
        </ion-button>
        <ion-button uppDataid="ticketview-cancel-return" expand="block" fill="clear" color="success" (click)="control.CancelAction()">
            {{tr('@place_ticket_cancel')}}
        </ion-button>
    </upp-form-buttons>
</ng-template>

<ng-template #ticketmixedaction>
    <ion-item class="action">
        <ion-label>{{tr('@place_ticket_action_payment')}}</ion-label>
        <ion-icon slot="end" name="logo-usd"></ion-icon>
    </ion-item>
    <upp-form-section fill="clear" [formGroup]="control.PaymentForm">
        <ion-item lines="full">
            <ion-icon slot="start" name="cash-outline"></ion-icon>
            <upp-input uppDataid="ticketedit-mixed-cash-text" 
                formControlName="cash" 
                type='price' 
                placeholder="{{tr('@place_ticket_enter_cash_ph')}}"
            ></upp-input>    
        </ion-item>
        <ion-item lines="none">
            <ion-icon slot="start" name="card-outline"></ion-icon>
            <upp-input uppDataid="ticketedit-mixed-card-text" 
                formControlName="card" 
                type='price' 
                placeholder="{{tr('@place_ticket_enter_card_ph')}}"
            ></upp-input>                
        </ion-item>
        <ion-button uppDataid="ticketview-submit-mixed" expand="block" color="success" [disabled]="!control.MixedReady" (click)="control.OnMixedPayment()">
            {{tr('@place_ticket_accept')}}
        </ion-button>            
        <ion-button uppDataid="ticketview-cancel-mixed" expand="block" fill="clear" color="success" (click)="control.CancelAction()">
            {{tr('@place_ticket_cancel')}}
        </ion-button>
    </upp-form-section>
</ng-template>

<ng-template #ticketpartialaction>
    <ion-item class="action">
        <ion-label>{{tr('@place_ticket_action_partial_payment')}}</ion-label>
        <ion-icon slot="end" name="logo-usd"></ion-icon>
    </ion-item>
    <upp-form-section fill="clear" [formGroup]="control.PartialForm">
        <ion-item lines="full">
            <ion-icon slot="start" name="cash-outline"></ion-icon>
            <upp-input uppDataid="ticketedit-partial-cash-text"
                formControlName="cash"
                type='price'
                placeholder="{{tr('@place_ticket_enter_cash_ph')}}"
            ></upp-input>
        </ion-item>
        <ion-item lines="none">
            <ion-icon slot="start" name="card-outline"></ion-icon>
            <upp-input uppDataid="ticketedit-partial-card-text"
                formControlName="card"
                type='price'
                placeholder="{{tr('@place_ticket_enter_card_ph')}}"
            ></upp-input>
        </ion-item>
        <ion-button uppDataid="ticketview-submit-partial" expand="block" color="success" [disabled]="!control.PartialReady" (click)="control.OnPartialPayment()">
            {{tr('@place_ticket_accept')}}
        </ion-button>
        <ion-button uppDataid="ticketview-cancel-partial" expand="block" fill="clear" color="success" (click)="control.CancelAction()">
            {{tr('@place_ticket_cancel')}}
        </ion-button>
    </upp-form-section>
</ng-template>

<ng-template #ticketemptyinfo>
    <ng-container *ngIf="ticket && (IsNewTicket === true)">
        <ion-button uppDataid="ticketedit-table-button" *ngIf="ticket.qrcode !== null" style="margin: 10px 10px 0px 10px;" color="medium" size="large" expand="block" (click)="OnViewTable()">
            <ion-label>{{tr('@ticket_view_table')}}</ion-label>
        </ion-button>
        <ion-card uppDataid="ticketedit-empty-warning" color="light">
            <ion-icon name="cart-outline"></ion-icon>
            <ion-card-header>
                <ion-card-subtitle>{{tr('@ticket_empty_cart_title')}}</ion-card-subtitle>
                <ion-card-title>{{tr('@ticket_empty_cart_message')}}</ion-card-title>
            </ion-card-header>   
        </ion-card>     
        <ng-container *ngIf="ticket.qrcode !== null">
            <upp-form-section fill="clear" title="{{tr('@ticket_table_list_tickets')}}">
                <upp-form-warning uppDataid="ticketedit-notickets-warning"
                    *ngIf="TableTickets.length === 0"
                    color="success"
                    slot="start"
                    icon="checkmark-circle-outline"
                    title="{{tr('@ticket_table_empty_tickets_title')}}"
                    subtitle="{{tr('@ticket_table_empty_tickets_message')}}"
                ></upp-form-warning>
                <ng-container *ngFor="let _ticket of TableTickets; trackBy: TicketTrack">
                    <upp-ticket-thumb [uppDataid]="'ticketedit-tableticket-' + _ticket.orderno + '-thumb'"  [ticket]="_ticket"  (click)="OnSelectTicket(_ticket)"></upp-ticket-thumb>
                </ng-container>
            </upp-form-section>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="ticket && (IsNewTicket !== true)">
        <ion-card uppDataid="ticketedit-empty-warning" color="light">
            <ion-icon name="cart-outline"></ion-icon>
            <ion-card-header>
                <ion-card-subtitle>{{tr('@ticket_empty_cart_title')}}</ion-card-subtitle>
                <ion-card-title>{{tr('@ticket_empty_cart_message')}}</ion-card-title>
            </ion-card-header>   
        </ion-card> 
        <upp-form-section fill="clear" title="{{tr('@ticket_order_notes')}}">
            <upp-textarea uppDataid="ticketedit-notes-area" [rows]="5"
                [(ngModel)]="Comments"
                placeholder="{{tr('@ticket_order_notes_ph')}}"
            ></upp-textarea>
        </upp-form-section>
    </ng-container>
</ng-template>

<ng-template #ticketprodts>
    <ng-container *ngIf="ticket && (ToPrepareProducts.length > 0)">
        <!-- PRODUCTS TO BE PREPARED -->
        <upp-form-section fill="clear" style="margin-top: 10px">
            <ion-item class="title">
                <ion-label>{{tr('@place_ticket_products_to_prepare_title')}}</ion-label>
            </ion-item>
            <div class="drag-list" cdkDropList (cdkDropListDropped)="OnProductDrop($event, ToPrepareProducts)">
                <ng-container *ngFor="let product of ToPrepareProducts; trackBy: TicketProductTrack">
                    <span cdkDrag class="drag-box">
                        <div class="cdk-thumbnail-placeholder" *cdkDragPlaceholder></div>
                        <upp-product-ticket [mode]="ProductMode" [product]="product" [expand]="IsLocked" (Updated)="OnUpdated()" (ToPanel)="OnPanel($event)" (OnSlide)="OnProductSlider($event)" (OnUnits)="OnUnitsSelection($event)"></upp-product-ticket>
                        <div [hidden]="mode === 'VIEW' || IsLocked || IsProductSlider(product)" cdkDragHandle class="drag-icon">
                            <ion-icon name="swap-vertical-outline"></ion-icon>  
                        </div>                        
                    </span>
                </ng-container>
            </div>
            <ion-button uppDataid="ticketedit-add-separator" [hidden]="mode === 'VIEW' || IsLocked" expand="block" color="medium" [disabled]="!CanSeparate" (click)="OnSeparate()">
                {{tr('@ticket_add_separator')}}
            </ion-button>
        </upp-form-section>
    </ng-container>
</ng-template>

<ng-template #ticketextras>
    <ng-container *ngIf="ticket && (ticket.extras.length > 0)">
        <upp-form-section fill="clear" style="margin-top: 10px">
            <ion-item class="title">
                <ion-label color="dark">{{tr('@ticket_order_extras_title')}}</ion-label>
            </ion-item>
            <ng-container *ngFor="let _extra of ticket.extras">
                <upp-extra-ticket uppDataid="ticketedit-extra-info" [mode]="ProductMode" [extra]="_extra" (Updated)="OnUpdated()" (ToPanel)="OnPanel($event)"></upp-extra-ticket>
            </ng-container>
        </upp-form-section>
    </ng-container>    
</ng-template>

<ng-template #ticketoffers>
    <ng-container *ngIf="ticket && (ticket.offers.length > 0)">
        <upp-form-section fill="clear" style="margin-top: 10px">
            <ion-item class="title">
                <ion-label color="dark">{{tr('@ticket_order_offers_title')}}</ion-label>
            </ion-item>
            <ng-container *ngFor="let _offer of ticket.offers">
                <upp-offer-ticket *ngIf="_offer.Display" uppDataid="ticketedit-offer-info" [mode]="ProductMode" [offer]="_offer" (Updated)="OnUpdated()" (ToPanel)="OnPanel($event)"></upp-offer-ticket>
            </ng-container>
        </upp-form-section>      
    </ng-container>
</ng-template>

<ng-template #ticketdscnts>
    <ng-container *ngIf="ticket && (ticket.discounts.length > 0)">
        <upp-form-section fill="clear" style="margin-top: 10px">
            <ion-item class="title">
                <ion-label color="dark">{{tr('@ticket_order_discounts_title')}}</ion-label>
            </ion-item>
            <ng-container *ngFor="let _discount of ticket.discounts">
                <upp-offer-ticket uppDataid="ticketedit-discount-info" [mode]="ProductMode" [discount]="_discount" (Updated)="OnUpdated()" (ToPanel)="OnPanel($event)"></upp-offer-ticket>
            </ng-container>
        </upp-form-section>
    </ng-container>
</ng-template>

<ng-template #applycomments>
    <upp-form-section *ngIf="mode === 'EDIT' && !IsLocked" fill="clear" style="margin-top: 10px">
        <ion-item class="title">
            <ion-label color="dark">{{tr('@ticket_order_notes')}}</ion-label>
        </ion-item>
        <ng-container *ngIf="ticket as t">
            <div class="ticket-diners" *ngIf="CanDiners && t.diners !== null && t.diners !== 0">
                <ion-item uppDataid="ticketedit-diners-row" class="diners" lines="none">
                    <ion-icon slot="start" name="people-outline"></ion-icon>
                    <ion-label>{{tr('@ticket_diners_set_size', [ t.diners ])}}</ion-label>
                </ion-item>
            </div>
        </ng-container>
        <upp-textarea uppDataid="ticketedit-notes-area" [rows]="5"
            [(ngModel)]="Comments"
            placeholder="{{tr('@ticket_order_notes_ph')}}"
            (Changed)="OnUpdated()"
        ></upp-textarea>
    </upp-form-section>
</ng-template>

<ng-template #ticketeditaction>
    <ng-container *ngIf="ticket">
        <ng-container *ngIf="ticket.empty === true">
            <ng-container [ngTemplateOutlet]="ticketemptyinfo"></ng-container>
        </ng-container>
        <ng-container *ngIf="ticket.empty !== true">
            <ng-container [ngTemplateOutlet]="ticketprodts"></ng-container>

            <ng-container [ngTemplateOutlet]="ticketextras"></ng-container>
            <ng-container [ngTemplateOutlet]="ticketoffers"></ng-container>
            <ng-container [ngTemplateOutlet]="ticketdscnts"></ng-container>
        </ng-container>

        <ng-container [ngTemplateOutlet]="applycomments"></ng-container>
    </ng-container>
</ng-template>

<upp-visible-control mode="fill">
    <upp-panel *ngIf="ticket" [size]="view.Mobile ? 'auto' : 'large'">
        <upp-panel-header>    
            <ng-container [ngTemplateOutlet]="ticketheader"></ng-container>
        </upp-panel-header>
        <ng-container *ngIf="CanDiners">
            <upp-dropdown [expand]="ShowDiners" (Closed)="OnDiners()">
                <upp-dropdown-title>
                    {{tr('@ticket_choose_diners_size')}}
                </upp-dropdown-title>
                <upp-dropdown-content>
                    <ion-item *ngFor="let size of DinerPresets" [uppDataid]="'ticketedit-diners-' + size" (click)="SetDinersSize(size)">
                        <ion-label>{{tr('@ticket_diners_set_size', [ size ])}}</ion-label>
                        <ion-icon slot="end" name="people-outline"></ion-icon>
                    </ion-item>
                    <ion-item lines="none">
                        <upp-input uppDataid="ticketedit-diners-text"
                            type="number"
                            placeholder="{{tr('@ticket_choose_diners_other')}}"
                            (Changed)="OnDinersOther($event)"
                        ></upp-input>
                    </ion-item>
                </upp-dropdown-content>
            </upp-dropdown>
        </ng-container>
        <upp-panel-content class="--no-fill-children">
            <!-- show warning when invoice is required -->
            <ng-container *ngIf="ticket.ToInvoice">
                <ion-item uppDataid="ticketedit-invoice-warning" color="warning" class="warning">
                    <ion-icon slot="start" name="logo-usd"></ion-icon>
                    <ion-label>
                        {{tr('@place_ticket_invoice_required', [ ticket.maxprice, tr('@currency') ] )}}<br/>
                        <span class="small">{{tr('@place_ticket_invoice_required_text')}}</span>
                    </ion-label>
                </ion-item>  
            </ng-container>

            <!-- show warning when a partial payment is in progress -->
            <ng-container *ngIf="ticket.HasPartial">
                <ion-item uppDataid="ticketedit-partial-warning" color="warning" class="warning">
                    <ion-icon slot="start" name="logo-usd"></ion-icon>
                    <ion-label>
                        {{tr('@place_ticket_partial_payment_warning', [ ticket.paid.toFixed(2), tr('@currency') ])}}<br/>
                        <span class="small">{{tr('@place_ticket_partial_payment_pending', [ ticket.due.toFixed(2), tr('@currency') ])}}</span>
                    </ion-label>
                </ion-item>
            </ng-container>

            <!-- pending card-terminal unlock (same ion-item.warning chrome as invoice / QR) -->
            <upp-pinpad-ticket
                uppDataid="ticketedit-cardterm"
                [ticket]="ticket"
                [place]="place"
                (OnApplied)="OnPinpadTicketApplied()"
                (OnMutated)="OnPinpadTicketMutated()">
            </upp-pinpad-ticket>

            <!-- show origin banner when the ticket was created by a guest (QR) or web (HM) -->
            <ng-container *ngIf="ticket.source === 'QR'">
                <ion-item uppDataid="ticketedit-source-app-warning" color="success" class="warning" lines="none">
                    <ion-icon slot="start" name="person"></ion-icon>
                    <ion-label>
                        {{tr('@place_ticket_source_app')}}<br/>
                        <span class="small">{{tr('@place_ticket_source_app_text')}}</span>
                    </ion-label>
                </ion-item>
            </ng-container>
            <ng-container *ngIf="ticket.source === 'HM'">
                <ion-item uppDataid="ticketedit-source-web-warning" color="success" class="warning" lines="none">
                    <ion-icon slot="start" name="home"></ion-icon>
                    <ion-label>
                        {{tr('@place_ticket_source_web')}}<br/>
                        <span class="small">{{tr('@place_ticket_source_web_text')}}</span>
                    </ion-label>
                </ion-item>
            </ng-container>

            <ng-container *ngIf="(control.action === 'edit') && !ticket.pendpay && !ticket.empty">
                <ng-container [ngTemplateOutlet]="ticketactions"></ng-container>
                <ng-container [ngTemplateOutlet]="ticketbuttons"></ng-container>
            </ng-container>

            <upp-form layout="fill">
                <ng-container *ngIf="control.action === 'table'" [ngTemplateOutlet]="tickettableaction"></ng-container>
                <ng-container *ngIf="control.action === 'account'" [ngTemplateOutlet]="ticketaccountaction"></ng-container>
                <ng-container *ngIf="control.action === 'discount'" [ngTemplateOutlet]="ticketdiscountaction"></ng-container>
                <ng-container *ngIf="control.action === 'merge'" [ngTemplateOutlet]="ticketmergeaction"></ng-container>
                <ng-container *ngIf="control.action === 'split'" [ngTemplateOutlet]="ticketsplitaction"></ng-container>
                <ng-container *ngIf="control.action === 'return'" [ngTemplateOutlet]="ticketreturnaction"></ng-container>
                <ng-container *ngIf="control.action === 'mixed'" [ngTemplateOutlet]="ticketmixedaction"></ng-container>
                <ng-container *ngIf="control.action === 'partial'" [ngTemplateOutlet]="ticketpartialaction"></ng-container>
                <ng-container *ngIf="control.InvoiceWarning" [ngTemplateOutlet]="ticketinvoiceaction"></ng-container>
                
                <div [hidden]="((control.action !== 'edit') && (control.action !== 'split') && (control.action !== 'return')) || ticket.pendpay">
                    <ng-container [ngTemplateOutlet]="ticketeditaction"></ng-container>
                </div>

                <ng-container *ngIf="control.action === 'return'" [ngTemplateOutlet]="ticketreturnoptions"></ng-container>
                
                <ng-container *ngIf="control.action === 'merge'" [ngTemplateOutlet]="ticketmergebuttons"></ng-container>
                <ng-container *ngIf="control.action === 'split'" [ngTemplateOutlet]="ticketsplitbuutons"></ng-container>
                <ng-container *ngIf="control.action === 'return'" [ngTemplateOutlet]="ticketreturnbuttons"></ng-container>
            </upp-form>
        </upp-panel-content>
    </upp-panel>
</upp-visible-control>

<upp-dialog *ngIf="PayCashTickets !== null"
    [backdropDismiss]="false"
    style="--upp-dialog-panel-width: 420px"
    (OnClose)="OnPayCashClose()">
    <upp-modal-cashpay
        [tickets]="PayCashTickets"
        (OnAccept)="OnPayCashAccept($event)"
        (OnClose)="OnPayCashClose()">
    </upp-modal-cashpay>
</upp-dialog>

<upp-dialog *ngIf="PayCardTickets !== null"
    [backdropDismiss]="false"
    style="--upp-dialog-panel-width: 420px"
    (OnClose)="OnPayCardClose()">
    <upp-modal-cardpay
        [tickets]="PayCardTickets"
        (OnAccept)="OnPayCardAccept()"
        (OnClose)="OnPayCardClose()">
    </upp-modal-cardpay>
</upp-dialog>

<upp-pinpad-session></upp-pinpad-session>

